import { Tabs } from 'antd';
import { SavedProjects } from './SavedProjectsTab/SavedProjects';
import { ProjectDto } from '@/core';
import classes from './ProjectReportsTabs.module.scss';
import { ReportsStatisticTab } from './ReportsStatisticTab/ReportsStatisticTab';

type ProjectReportsTabsPropsType = {
  projectData: ProjectDto;
};

export const ProjectReportsTabs = ({ projectData }: ProjectReportsTabsPropsType) => {
  return (
    <Tabs defaultActiveKey="1" className={classes.tabsWrapper}>
      <Tabs.TabPane tab="Dashboard" key="1">
        <ReportsStatisticTab projectData={projectData} />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Reports" key="2">
        <SavedProjects projectData={projectData} />
      </Tabs.TabPane>
    </Tabs>
  );
};
